import { getConsent } from "./cookies";

export const initAnalytics = async (pageName) => {
  const consent = getConsent();

  if (!consent?.analytics) {
    console.log("❌ Analytics blocked by user");
    return;
  }

  console.log("✅ Analytics allowed");

  // ===============================
  // 🔥 VISITED PAGES ARRAY TRACKING
  // ===============================

  let visitedPages =
    JSON.parse(sessionStorage.getItem("visited_pages")) || [];

  if (pageName && !visitedPages.includes(pageName)) {
    visitedPages.push(pageName);
  }

  sessionStorage.setItem(
    "visited_pages",
    JSON.stringify(visitedPages)
  );

  // ===============================
  // DEVICE DETECTION
  // ===============================

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  // ===============================
  // IP + LOCATION FETCH
  // ===============================

  let ip = "Unknown";
  let country = "Unknown";
  let city = "Unknown";

  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    ip = data.ip;
    country = data.country_name;
    city = data.city;
  } catch (error) {
    console.log("IP fetch failed");
  }

  // ===============================
  // FULL VISITOR OBJECT (NO DATA REMOVED)
  // ===============================

  const userInfo = {
    timestamp: new Date().toISOString(),
    currentPage: pageName || "Unknown",
    visitedPages,

    url: window.location.href,
    referrer: document.referrer || "Direct",

    userAgent: navigator.userAgent,
    browser: navigator.appName,
    browserVersion: navigator.appVersion,
    platform: navigator.platform,
    language: navigator.language,
    cookiesEnabled: navigator.cookieEnabled,
    onlineStatus: navigator.onLine,

    screenResolution: `${window.screen.width}x${window.screen.height}`,
    deviceType: isMobile ? "Mobile" : "Desktop",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    ipAddress: ip,
    country,
    city,
  };

  console.log("🔥 Visitor Log:");
  console.table(userInfo);
};
